export const getDqMemoKey = (dqKey: string) => 'DQ:' + dqKey
export const MEMO_KEY_KOST = 'KOST'
